import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00888ff0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-boldest m-0" }
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group d-flex flex-wrap" }
const _hoisted_9 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group d-flex flex-wrap" }
const _hoisted_12 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group d-flex flex-wrap" }
const _hoisted_16 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group d-flex flex-wrap" }
const _hoisted_19 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group d-flex flex-wrap" }
const _hoisted_23 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_24 = { class: "badge badge-light-primary" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "form-group d-flex flex-wrap" }
const _hoisted_27 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_28 = {
  key: 0,
  class: "badge badge-light-danger"
}
const _hoisted_29 = {
  key: 1,
  class: "badge badge-light-success"
}
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-group d-flex flex-wrap" }
const _hoisted_33 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-12" }
const _hoisted_36 = { class: "form-group d-flex flex-wrap" }
const _hoisted_37 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1))
const _hoisted_39 = { class: "card-body p-0" }
const _hoisted_40 = { class: "upload-img-box" }
const _hoisted_41 = ["src"]
const _hoisted_42 = { class: "el-upload-list__item-actions" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "mt-1" }
const _hoisted_46 = {
  style: {"align-items":"center","justify-content":"center","display":"flex"},
  class: "mb-10"
}
const _hoisted_47 = ["src"]
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-md-12" }
const _hoisted_50 = { class: "form-group d-flex flex-wrap" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Check Point ", -1))
const _hoisted_52 = {
  key: 0,
  class: "row"
}
const _hoisted_53 = { class: "col-md-12" }
const _hoisted_54 = { class: "form-group d-flex flex-wrap" }
const _hoisted_55 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_56 = {
  key: 1,
  class: "row"
}
const _hoisted_57 = { class: "mb-10" }
const _hoisted_58 = { class: "multi-image-labels min" }
const _hoisted_59 = { class: "el-upload-list el-upload-list--picture-card" }
const _hoisted_60 = { class: "upload-img-box" }
const _hoisted_61 = ["src"]
const _hoisted_62 = ["data-bs-target"]
const _hoisted_63 = { class: "form-group" }
const _hoisted_64 = { style: {"margin-left":"5px"} }
const _hoisted_65 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_66 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_67 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_69 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_70 = { class: "indicator-label" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1))
const _hoisted_72 = { class: "indicator-progress" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_plus = _resolveComponent("plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_zoom_in = _resolveComponent("zoom-in")!
  const _component_delete = _resolveComponent("delete")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_selectImgModal = _resolveComponent("selectImgModal")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_FsLightbox = _resolveComponent("FsLightbox")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      rules: _ctx.rules,
      model: _ctx.formData,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("common.information")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("inspectionReport.stockInId")), 1),
                  _createVNode(_component_el_form_item, { prop: "stock_in_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.stock_in_id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.stock_in_id) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("inspectionReport.inventoryId")), 1),
                  _createVNode(_component_el_form_item, { prop: "inventory_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.inventory_id,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.inventory_id) = $event)),
                        disabled: "",
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("order.skuIdentifier")), 1),
                  _createVNode(_component_el_form_item, { prop: "sku_identifier" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.sku_identifier,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.sku_identifier) = $event)),
                        disabled: "",
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("inspectionReport.identifierCode")), 1),
                  _createVNode(_component_el_form_item, { prop: "identifier_code" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.identifier_code,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.identifier_code) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: "",
                        disabled: _ctx.options.identifier_code !== ''
                      }, null, 8, ["modelValue", "placeholder", "disabled"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t("inspectionReport.warehouse")), 1),
                  _createVNode(_component_el_form_item, { prop: "warehouse" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.formData.__show.warehouse), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.t("inspectionReport.inspectionStatus")), 1),
                  _createVNode(_component_el_form_item, { prop: "inspection_status" }, {
                    default: _withCtx(() => [
                      (_ctx.formData.inspection_status == 10)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.t("inspectionReport.failed")), 1))
                        : (_ctx.formData.inspection_status == 20)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.t("inspectionReport.passed")), 1))
                          : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.t("inspectionReport.inspectionManager")), 1),
                  _createVNode(_component_el_form_item, { prop: "inspection_manager" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.__show.inspection_manager,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.__show.inspection_manager) = $event)),
                        disabled: "",
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.t("inspectionReport.inspectionNotes")), 1),
                  _createVNode(_component_el_form_item, { prop: "inspection_notes" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.inspection_notes,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.inspection_notes) = $event)),
                        type: "textarea",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("h3", null, _toDisplayString(_ctx.t("inspectionReport.inspections")), 1),
            _hoisted_38,
            _createVNode(_component_el_upload, {
              class: "mb-7 multi-image-labels",
              action: _ctx.uploadImage,
              data: { id: _ctx.$route.params.id },
              headers: _ctx.uploadHeaders,
              "list-type": "picture-card",
              multiple: "",
              "file-list": _ctx.fileList,
              ref: "inspectionsUpload",
              disabled: !_ctx.checkPermissionFlag({ auth: ['update'] })
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_plus)
                  ]),
                  _: 1
                })
              ]),
              file: _withCtx(({ file }) => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("img", {
                      style: {"object-fit":"contain"},
                      class: "el-upload-list__item-thumbnail",
                      src: file.url,
                      alt: ""
                    }, null, 8, _hoisted_41),
                    _createElementVNode("span", _hoisted_42, [
                      _createElementVNode("span", {
                        class: "el-upload-list__item-preview",
                        onClick: ($event: any) => (_ctx.handlePreview(file))
                      }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_zoom_in)
                          ]),
                          _: 1
                        })
                      ], 8, _hoisted_43),
                      _createElementVNode("span", {
                        class: "el-upload-list__item-delete",
                        onClick: ($event: any) => (_ctx.handleRemove(file))
                      }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_delete)
                          ]),
                          _: 1
                        })
                      ], 8, _hoisted_44)
                    ])
                  ])
                ])), [
                  [_directive_loading, file.name && !file.response?.data[0].image]
                ]),
                _createElementVNode("div", _hoisted_45, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(file.check_point
                  ? file.check_point
                  : file.response?.data[0].check_point, (item, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: "badge badge-light-dark me-2 mt-2",
                      key: index
                    }, _toDisplayString(_ctx.getLabel(item, "inspections")), 1))
                  }), 128))
                ]),
                (file.dialogVisible)
                  ? (_openBlock(), _createBlock(_component_el_dialog, {
                      key: 0,
                      modelValue: file.dialogVisible,
                      "onUpdate:modelValue": ($event: any) => ((file.dialogVisible) = $event)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("img", {
                            src: _ctx.dialogImageUrl,
                            alt: "",
                            style: {"width":"100%","max-width":"300px"}
                          }, null, 8, _hoisted_47)
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, [
                              _hoisted_51,
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: file.check_point,
                                    "onUpdate:modelValue": ($event: any) => ((file.check_point) = $event),
                                    clearable: "",
                                    filterable: "",
                                    multiple: "",
                                    placeholder: _ctx.t('common.plsSelect'),
                                    style: {"width":"100%"},
                                    onChange: ($event: any) => (_ctx.changeCheckPoint(file))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.inspections, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "onChange"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["action", "data", "headers", "file-list", "disabled"]),
            (_ctx.options.inspections.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.t("inspectionReport.checkPointList")), 1),
                      _createVNode(_component_el_form_item, { prop: "inspections.check_point" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.inspections.check_point,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.inspections.check_point) = $event)),
                            filterable: "",
                            multiple: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.inspections, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.options.inspections.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createVNode(_component_el_table, {
                      data: _ctx.formData.inspections.data,
                      style: {"width":"100%"},
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          width: "120px",
                          label: _ctx.t('inspectionReport.checkPoint'),
                          prop: "__show.check_point_label"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          width: "600px",
                          label: _ctx.t('common.images')
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_58, [
                              _createElementVNode("ul", _hoisted_59, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row
                          .warehouse_quality_inspection_images_id, (item, index) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    class: "el-upload-list__item is-success",
                                    key: index
                                  }, [
                                    _createElementVNode("div", _hoisted_60, [
                                      _createElementVNode("img", {
                                        class: _normalizeClass(`img_${item.id}`),
                                        src: item.url,
                                        alt: ""
                                      }, null, 10, _hoisted_61)
                                    ])
                                  ]))
                                }), 128))
                              ]),
                              _createElementVNode("div", {
                                class: "el-upload el-upload--picture-card",
                                "data-bs-toggle": "modal",
                                "data-bs-target": `#modal_select_img_${scope.row.check_point}`
                              }, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_plus)
                                  ]),
                                  _: 1
                                })
                              ], 8, _hoisted_62),
                              (_ctx.inspectionsUpload)
                                ? (_openBlock(), _createBlock(_component_selectImgModal, {
                                    key: 0,
                                    fileList: _ctx.inspectionsUpload.uploadRef.fileList,
                                    checkPoint: scope.row.check_point,
                                    checkboxFile: 
                        scope.row.warehouse_quality_inspection_images_id.map(
                          (o) => {
                            return Number([o.id].toString());
                          }
                        )
                      ,
                                    onUpdateImgList: _ctx.updateImgList
                                  }, null, 8, ["fileList", "checkPoint", "checkboxFile", "onUpdateImgList"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('inspectionReport.result')
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_63, [
                              _createVNode(_component_el_form_item, { prop: "status" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_switch, {
                                    modelValue: scope.row.result,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.result) = $event),
                                    "active-value": 20,
                                    "inactive-value": 10
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                  _createElementVNode("span", _hoisted_64, [
                                    (scope.row.result == 20)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(_ctx.t("inspectionReport.passed")), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.t("inspectionReport.failed")), 1))
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('inspectionReport.notice'),
                          width: "220"
                        }, {
                          default: _withCtx(({ row, $index }) => [
                            _createVNode(_component_el_form_item, {
                              rules: _ctx.rules['inspections.data.notice'],
                              prop: 'inspections.data.' + $index + '.notice'
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: row.notice,
                                  "onUpdate:modelValue": ($event: any) => ((row.notice) = $event),
                                  type: "text",
                                  placeholder: _ctx.t('common.plsEnter'),
                                  clearable: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                              ]),
                              _: 2
                            }, 1032, ["rules", "prop"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_68,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_69, [
              _createElementVNode("span", _hoisted_70, [
                _hoisted_71,
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
              ]),
              _createElementVNode("span", _hoisted_72, [
                _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                _hoisted_73
              ])
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["rules", "model"]),
    _createVNode(_component_FsLightbox, {
      toggler: _ctx.options.toggler,
      sources: _ctx.options.sources,
      slide: _ctx.options.sourcesSlide
    }, null, 8, ["toggler", "sources", "slide"])
  ], 64))
}